package com.essntl.features.proposal.ui.proposalhistory

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.proposal.ui.proposalhistory.components.JourneyRowUiState
import com.essntl.features.request.domain.model.RequestModel

data class ProposalOverviewState(
    val getProposal: State<ProposalModel> = State(),
    val proposalParentStatus: ProposalModel.Status? = null,
    val getAllProposalService: State<List<ProposalServiceModel>> = State(),
    val getAllRequest: State<List<RequestModel>> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getAllCategory: State<List<CategoryModel>> = State(),
    val getCoverImage: State<FileModel> = State(),
    val getCurrentProfile: State<ProfileModel> = State(),
) {
    val isLoading: Boolean
        get() = getProposal.isLoading ||
            getAllProposalService.isLoading ||
            getCoverImage.isLoading

    val isFailure: Boolean
        get() = getProposal.isFailure ||
            getAllProposalService.isFailure ||
            getCoverImage.isFailure

    fun toUiState(): List<JourneyRowUiState> =
        getAllProposalService.data.orEmpty()
            .map {
                JourneyRowUiState(
                    id = it.id,
                    index = it.index,
                    startTime = it.startTime,
                    price = it.price,
                    priceCurrencySymbol = it.priceCurrency?.symbol,
                    startDate = it.startDate,
                    service = it.service,
                    isItinerary = false,
                )
            }
}
